var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53 8.36v6.83l6.45-3.42-6.45-3.41zm2.51-4.94c.45 0 5.15.01 8.36.23.45.08 1.5.08 2.4 1.06.75.76.98 2.43.98 2.43s.22 1.98.22 3.95v2.05c-.01 1.74-.19 3.43-.22 3.68v.03s-.23 1.67-.98 2.43c-.9.99-1.95.99-2.4 1.06-2.96.2-7.2.22-8.19.23h-.22c-.3 0-6.26-.08-8.16-.23-.53-.14-1.73-.07-2.63-1.05-.75-.76-.98-2.43-.98-2.43S0 14.88 0 12.91v-2.05c.02-1.9.22-3.72.22-3.72s.23-1.67.98-2.43c.9-.99 1.95-.99 2.4-1.06 3.21-.22 7.91-.23 8.36-.23h.08z"
  })));
}

export default SvgSocialYoutube;